/**
 * Unified Supabase exports for React Native/web
 * 
 * This file re-exports from supabase.ts for use in React Native/web environments.
 * 
 * IMPORTANT: This file should NEVER detect or import from supabase-node.ts,
 * as Metro bundler runs in Node.js during build and would try to bundle
 * Node.js-specific dependencies (path, dotenv) into the mobile app.
 * 
 * For Node.js scripts: Import directly from supabase-node.ts
 * For React Native/web: Import from this file (or supabase.ts directly)
 */
export { handleSupabaseList, handleSupabaseSingle, supabase } from './supabase';
